import PropTypes from "prop-types";

import "../styles/ActionButton.scss";

/**
 * A button for performing various actions (submit, open, close, cancel, etc)
 * @name ActionButton
 * @param className
 * @param id
 * @param label
 * @param onClick
 * @return {JSX.Element}
 * @constructor
 */
const ActionButton = ({ className, disable, id, label, name, onClick, onMouseEnter, onMouseLeave, type, value }) => {
    return (
        <button
            className={className}
            id={id}
            disabled={disable}
            name={name}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            tabIndex={0}
            type={type}
            value={value}
        >
            {label}
        </button>
    );
};

ActionButton.propTypes = {
    className: PropTypes.string,
    disable: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    name: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.string
};

ActionButton.defaultProps = {
    className: "action-button-reg",
    disable: false,
    id: "",
    label: "",
    name: "",
    onClick: null,
    onMouseEnter: null,
    onMouseLeave: null,
    type: "button",
    value: ""
};

export default ActionButton;
